import React, { FC, ReactNode } from 'react'

import ContentWrapper from './ContentWrapper'
import Sidebar from './Sidebar'

type Props = {
  sidebar?: ReactNode
}

const Layout: FC<Props> = (props) => {
  const { children, sidebar } = props

  return (
    <div className="w-full px-5 py-9 lg:p-9 flex">
      {sidebar && <Sidebar>{sidebar}</Sidebar>}
      {children && <ContentWrapper>{children}</ContentWrapper>}
    </div>
  )
}

export default Layout
